import { render, staticRenderFns } from "./LoanSummary.vue?vue&type=template&id=95bfb376&scoped=true&"
import script from "./LoanSummary.vue?vue&type=script&lang=ts&"
export * from "./LoanSummary.vue?vue&type=script&lang=ts&"
import style0 from "./LoanSummary.vue?vue&type=style&index=0&id=95bfb376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bfb376",
  null
  
)

export default component.exports